const onlyEnglishCharsDirective = {
	mounted(el: HTMLElement) {
		const handler = (event: KeyboardEvent) => {
			// Regular expression to allow English letters, numbers, and special characters
			const allowedCharactersRegex =
				/^[A-Za-z0-9 !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;

			if (!allowedCharactersRegex.test(event.key)) {
				event.preventDefault();
			}
		};

		el.addEventListener('keydown', handler);

		// Store the handler function on the element to remove it later
		(el as any).__onlyEnglishCharsHandler__ = handler;
	},
	unmounted(el: HTMLElement) {
		const handler = (el as any).__onlyEnglishCharsHandler__;
		if (handler) {
			el.removeEventListener('keydown', handler);
		}
	},
};

export default onlyEnglishCharsDirective;
